import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Anchor, Repeat, Wind, Cloud, Mountain, KeyRound } from 'lucide-react';
import { SacredGeometry } from './SacredGeometry';
const painPoints = [{
  icon: Anchor,
  text: 'Sentís que algo te frena, pero no podés identificar qué es'
}, {
  icon: Repeat,
  text: 'Repetís los mismos patrones aunque conscientemente no querés'
}, {
  icon: Wind,
  text: 'Estás haciendo todo "bien" — y aun así algo no termina de fluir'
}, {
  icon: Cloud,
  text: 'Hay una sensación de peso, cansancio o bloqueo que no cede'
}, {
  icon: Mountain,
  text: 'Sentís que trabajaste mucho sobre vos mismo/a — y algo sigue sin moverse'
}, {
  icon: KeyRound,
  text: 'Algo en vos sabe que hay una capa más profunda que todavía no fue tocada'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function PainPoints() {
  return <section className="relative w-full bg-cream py-24 px-6 overflow-hidden" data-id="element-315">
      <div className="absolute top-0 right-0 w-96 h-96 translate-x-1/3 -translate-y-1/3 pointer-events-none" data-id="element-316">
        <SacredGeometry data-id="element-317" />
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-318">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-serif text-teal text-2xl md:text-3xl text-center uppercase tracking-widest mb-16" data-id="element-319">
          ¿Te suena familiar alguna de estas sensaciones?
        </motion.h2>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10 mb-20" data-id="element-320">
          {painPoints.map((point, index) => <motion.div key={index} variants={itemVariants} className="flex items-start gap-4" data-id="element-321">
              <div className="mt-1 flex-shrink-0 text-teal" data-id="element-322">
                <point.icon size={24} strokeWidth={1.5} data-id="element-323" />
              </div>
              <p className="text-lg text-gray-700 leading-relaxed font-light" data-id="element-324">
                {point.text}
              </p>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-center" data-id="element-325">
          <p className="font-serif italic text-xl md:text-2xl text-gray-800 leading-relaxed max-w-3xl mx-auto" data-id="element-326">
            "No siempre es posible resolver desde el lugar donde se originó.
            <br data-id="element-327" />A veces se necesita trabajar en el campo energético
            directamente."
          </p>
        </motion.div>
      </div>
    </section>;
}